module.exports = require("acorn");


//////////////////
// WEBPACK FOOTER
// external "acorn"
// module id = 122
// module chunks = 0